export const HistoricalDataName = 'oldDeclarationName';
export const HistoricalDataToolBarName = 'historicalDataToolBar';
